<template>
    <div class="container admin-table-page">
        <!-- ===== HEADER TÍTULO ===== -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.titulo1 }}</h2>
                </div>
            </div>
        </div>

        <!-- ===== FILTROS ===== -->
        <div class="param-title-wrap niif-header mt-2">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="filtroNit"
                        v-model="nitSeleccionado"
                        :options="opcionesCompanias"
                        value-field="nit"
                        text-field="label"
                        class="filter-select"
                    >
                        <b-form-select-option :value="null">
                            {{ labels.todasCompanias }}
                        </b-form-select-option>
                    </b-form-select>

                    <b-button
                        class="consult-btn ml-2"
                        @click="consultar()"
                        :disabled="!nitSeleccionado || isLoading"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <!-- ===== TARJETA ÚNICA ===== -->
        <div
            class="admin-table-block mt-4"
            :class="{ 'resumen-card': !isLoading && compania && compania.nit }"
        >
            <!-- ===== LOADING ===== -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>

            <!-- ===== SIN DATOS / ESTADO INICIAL ===== -->
            <div v-else-if="!compania || !compania.nit" class="text-center py-5">
                <font-awesome-icon
                    :icon="['fas', 'building']"
                    size="3x"
                    class="text-muted mb-3"
                    style="opacity: 0.3;"
                />
                <p class="h4 text-muted">{{ labels.noData }}</p>
                <p class="text-muted">{{ labels.noResults }}</p>
            </div>

            <!-- ===== RESULTADOS ===== -->
            <div v-else>
                <!-- Barra de acciones -->
                <div class="resumen-toolbar">
                    <div class="resumen-toolbar-title"></div>
                    <div class="resumen-toolbar-actions">
                        <b-button
                            size="sm"
                            class="table-toolbar-add-btn"
                            @click="abrirNuevoFormulario"
                        >
                            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                            {{ labels.nuevoFormulario }}
                        </b-button>
                    </div>
                </div>

                <!-- Bloques con scroll interno -->
                <div class="bloques-scroll">
                    <!-- Empresa -->
                    <div class="resumen-bloque">
                        <h5 class="bloque-titulo">{{ labels.empresa }}</h5>
                        <div class="empresa-grid">
                            <div class="empresa-field">
                                <span class="empresa-label">{{ labels.nit }}:</span>
                                <span class="empresa-value">{{ compania.nit || '-' }}</span>
                            </div>
                            <div class="empresa-field">
                                <span class="empresa-label">{{ labels.razonSocial }}:</span>
                                <span class="empresa-value">{{ compania.razon_social || '-' }}</span>
                            </div>
                            <div class="empresa-field">
                                <span class="empresa-label">{{ labels.departamento }}:</span>
                                <span class="empresa-value">{{ compania.compania_departamento || '-' }}</span>
                            </div>
                            <div class="empresa-field">
                                <span class="empresa-label">{{ labels.municipio }}:</span>
                                <span class="empresa-value">{{ compania.compania_municipio || '-' }}</span>
                            </div>
                            <div class="empresa-field">
                                <span class="empresa-label">{{ labels.direccion }}:</span>
                                <span class="empresa-value">{{ compania.direccion || '-' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- CIIUS -->
                    <div class="resumen-bloque">
                        <h5 class="bloque-titulo">{{ labels.ciius_titulo }}</h5>
                        <CorporateDataTable
                            :items="companiaCiius"
                            :fields="allFieldsCiius"
                            :labels="tableLabels"
                            :narrow="false"
                            :table-min-height="0"
                            :table-max-height="'none'"
                            :show-search="false"
                            :allow-column-toggle="false"
                            :enable-sorting="false"
                            :show-pagination="true"
                            :default-per-page="10"
                            :page-options="[10, 20, 50, 100]"
                        />
                    </div>

                    <!-- Municipios -->
                    <div class="resumen-bloque">
                        <h5 class="bloque-titulo">{{ labels.municipios }}</h5>
                        <CorporateDataTable
                            :items="companiaMunicipios"
                            :fields="allFieldsMunicipios"
                            :labels="tableLabels"
                            :narrow="false"
                            :table-min-height="0"
                            :table-max-height="'none'"
                            :show-search="false"
                            :allow-column-toggle="false"
                            :enable-sorting="false"
                            :show-pagination="true"
                            :default-per-page="10"
                            :page-options="[10, 20, 50, 100]"
                        >
                            <template #cell(accionEdit)="data">
                                <b-button style="background-color: #FF924C; width: 30px; height: 30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;" @click="editMunicipios(data.item)">
                                    <font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/>
                                </b-button>
                            </template>
                            <template #cell(accionDelete)="data">
                                <b-button class="reset-btn-danger" style="width: 30px; height: 30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;" @click="deleteFactura(data.item)">
                                    <font-awesome-icon :icon="['fas', 'trash']" size="xs"/>
                                </b-button>
                            </template>
                        </CorporateDataTable>
                    </div>

                    <!-- CIIUS POR MUNICIPIO -->
                    <div class="resumen-bloque">
                        <h5 class="bloque-titulo">{{ labels.ciiusPorMunicipio }}</h5>
                        <CorporateDataTable
                            :items="companiaMunicipiosCiius"
                            :fields="allFieldsMunicipiosCiius"
                            :labels="tableLabels"
                            :narrow="false"
                            :table-min-height="0"
                            :table-max-height="'none'"
                            :show-search="false"
                            :allow-column-toggle="false"
                            :enable-sorting="false"
                            :show-pagination="true"
                            :default-per-page="10"
                            :page-options="[10, 20, 50, 100]"
                        >
                            <template #cell(accionEdit)="data">
                                <b-button style="background-color: #FF924C; width: 30px; height: 30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;" @click="editMunicipiosCiius(data.item)">
                                    <font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/>
                                </b-button>
                            </template>
                            <template #cell(accionDelete)="data">
                                <b-button class="reset-btn-danger" style="width: 30px; height: 30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;" @click="deleteFactura(data.item)">
                                    <font-awesome-icon :icon="['fas', 'trash']" size="xs"/>
                                </b-button>
                            </template>
                        </CorporateDataTable>
                    </div>
                </div>
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- MODAL AGREGAR COMPAÑÍA                                       -->
        <!-- ============================================================ -->
        <b-modal
            :model-value="showNuevoFormulario"
            :no-close-on-backdrop="true" hide-footer centered size="lg"
            title="Agregar Compañía"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="cerrarModalCompania"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Agregar Compañía</div>
                    <div class="password-policy-subtitle">Ingresa los datos de la nueva compañía.</div>
                </div>

                <b-form @submit.prevent="guardarCompania">
                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">NIT</label>
                            <b-form-input v-model="formCompania.nit" required placeholder="Ej: 22222222" class="form-input" />
                        </b-col>
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Razón Social</label>
                            <b-form-input v-model="formCompania.razon_social" required placeholder="Nombre de la empresa" class="form-input" />
                        </b-col>
                    </b-row>

                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Departamento</label>
                            <b-form-select 
                                v-model="formCompania.divipol_depto" 
                                :options="opcionesDepartamentos" 
                                required
                                @change="formCompania.divipol_municipio = null"
                                class="form-input"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Municipio</label>
                            <b-form-select 
                                v-model="formCompania.divipol_municipio" 
                                :options="opcionesMunicipiosForm" 
                                required
                                :disabled="!formCompania.divipol_depto"
                                class="form-input"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="uniform-form-row">
                        <b-col md="12" class="fila-field">
                            <label class="field-label">Dirección</label>
                            <b-form-input v-model="formCompania.direccion" placeholder="Dirección de la empresa" class="form-input" />
                        </b-col>
                    </b-row>

                    <b-row class="uniform-form-row">
                        <b-col md="12" class="fila-field">
                            <label class="field-label required">Actividad Económica (CIIU)</label>
                            <b-form-select 
                                v-model="formCompania.actividades" 
                                :options="opcionesCiius" 
                                multiple
                                :select-size="5"
                                required
                                class="form-input"
                                style="height: auto;"
                            ></b-form-select>
                            <small class="text-muted">Mantén presionada la tecla Ctrl (o Cmd en Mac) para seleccionar varias.</small>
                        </b-col>
                    </b-row>

                    <b-row class="uniform-form-row">
                        <b-col md="12" class="fila-field">
                            <label class="field-label">Autoretenedor</label>
                            <div class="custom-toggle-wrapper custom-toggle-sm mt-1">
                                <input type="checkbox" id="toggle-autoretenedor" v-model="formCompania.autoretenedor" />
                                <label for="toggle-autoretenedor" class="toggle-label">
                                    <span class="toggle-slider"></span>
                                    <span class="toggle-text">{{ formCompania.autoretenedor ? 'Sí' : 'No' }}</span>
                                </label>
                            </div>
                        </b-col>
                    </b-row>

                    <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                        <b-button class="reset-btn-secondary" @click="cerrarModalCompania">Cancelar</b-button>
                        <b-button class="reset-btn-primary ml-2" type="submit">Guardar Compañía</b-button>
                    </div>
                </b-form>
            </div>
        </b-modal>

        <!-- ============================================================ -->
        <!-- MODAL MODIFICAR Municipios                                   -->
        <!-- ============================================================ -->
        <b-modal v-if="infoItem"
            :model-value="fglEditMunicipios"
            :no-close-on-backdrop="true" hide-footer centered size="lg"
            title="Codificación Interna de Municipios"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="fglEditMunicipios = false"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Codificación Interna de Municipios</div>
                    <div class="password-policy-subtitle">Modifica el código interno asignado al municipio.</div>
                </div>

                <b-form @submit.prevent="guardarMunicipio">
                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label">Código Interno</label>
                            <b-form-input v-model="infoItem.municipio" required readonly class="form-input" />
                        </b-col>
                    </b-row>
                    
                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label">Código Municipio</label>
                            <b-form-input v-model="infoItem.codigo_municipio" required readonly class="form-input" />
                        </b-col>
                        <b-col md="6" class="fila-field">
                            <label class="field-label">Municipio</label>
                            <b-form-input v-model="infoItem.descripcion_municipio" required readonly class="form-input" />
                        </b-col>
                    </b-row>
                    
                    <div class="text-center mt-3 mb-3">
                        <h5 class="text-primary" style="color: #2e507a !important;"><i>Cambio de Municipio</i></h5>
                    </div>

                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Departamento</label>
                            <b-form-select 
                                v-model="formCompania.divipol_depto" 
                                :options="opcionesDepartamentos" 
                                required
                                @change="formCompania.divipol_municipio = null"
                                class="form-input"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Municipio</label>
                            <b-form-select 
                                v-model="formCompania.divipol_municipio" 
                                :options="opcionesMunicipiosForm" 
                                required
                                :disabled="!formCompania.divipol_depto"
                                class="form-input"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                        <b-button class="reset-btn-secondary" @click="fglEditMunicipios = false; consultar()">Cancelar</b-button>
                        <b-button class="reset-btn-primary ml-2" type="submit">Guardar Codificación</b-button>
                    </div>
                </b-form>
            </div>
        </b-modal>

        <!-- ============================================================ -->
        <!-- MODAL MODIFICAR Municipios CIIUS                             -->
        <!-- ============================================================ -->
        <b-modal v-if="infoItem"
            :model-value="fglEditMunicipiosCiius"
            :no-close-on-backdrop="true" hide-footer centered size="lg"
            title="Tarifas de Impuestos CIIUS por Municipios"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="fglEditMunicipiosCiius = false"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Tarifas de Impuestos CIIUS por Municipios</div>
                    <div class="password-policy-subtitle">Ajusta las tarifas para este CIIU en el municipio seleccionado.</div>
                </div>

                <b-form @submit.prevent="guardarMunicipioCiiu">
                    <b-row class="uniform-form-row">
                        <b-col md="4" class="fila-field">
                            <label class="field-label">Código Municipio</label>
                            <b-form-input v-model="infoItem.codigo_municipio" required readonly class="form-input" />
                        </b-col>
                        <b-col md="8" class="fila-field">
                            <label class="field-label">Municipio</label>
                            <b-form-input v-model="infoItem.descripcion_municipio" required readonly class="form-input" />
                        </b-col>
                    </b-row>

                    <b-row class="uniform-form-row">
                        <b-col md="2" class="fila-field">
                            <label class="field-label">CIIU</label>
                            <b-form-input v-model="infoItem.ciiu" required readonly class="form-input" />
                        </b-col>
                        <b-col md="2" class="fila-field">
                            <label class="field-label">Alterno</label>
                            <b-form-input v-model="infoItem.alterno" required readonly class="form-input" />
                        </b-col>
                        <b-col md="8" class="fila-field">
                            <label class="field-label">Descripción</label>
                            <b-form-input v-model="infoItem.descripcion" required readonly class="form-input" />
                        </b-col>
                    </b-row>

                    <div class="text-center mt-3 mb-3">
                        <h5 class="text-primary" style="color: #2e507a !important;"><i>Cambio de Tarifas</i></h5>
                    </div>

                    <b-row class="uniform-form-row">
                        <b-col md="6" class="fila-field">
                            <label class="field-label required">Tarifa</label>
                            <b-form-input v-model="infoItem.porcentaje" required class="form-input" />
                        </b-col>
                        <b-col md="6" class="fila-field">
                            <label class="field-label">Valor x Millón</label>
                            <b-form-input v-model="infoItem.valorxmillon" class="form-input" />
                        </b-col>
                    </b-row>

                    <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                        <b-button class="reset-btn-secondary" @click="fglEditMunicipiosCiius = false; consultar()">Cancelar</b-button>
                        <b-button class="reset-btn-primary ml-2" type="submit">Guardar Tarifas</b-button>
                    </div>
                </b-form>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Companias from "@/services/Compania";
import Divipol from "@/services/Divipol";
import Ciius from "@/services/Ciius";
import CorporateDataTable from "../utils/CorporateDataTable.vue";

export default {
    name: 'Compania',
    components: {
        CorporateDataTable,
    },
    data() {
        return {
            compania: {},
            companiaMunicipios: [],
            companiaCiius: [],
            companiaMunicipiosCiius: [],
            departamentos: [],
            municipios: [],
            ciius: [],
            listaCompanias: [],
            nitSeleccionado: null,
            isLoading: false,
            showNuevoFormulario: false,
            formCompania: {
                nit: '',
                razon_social: '',
                divipol_depto: null,
                divipol_municipio: null,
                direccion: '',
                actividades: [],
                autoretenedor: false
            },
            fglEditMunicipios: false,
            fglEditMunicipiosCiius: false,
            infoItem: {},
        };
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    titulo1: "Industria y Comercio",
                    empresa: "Empresa",
                    ciius: "Codigo CIIU",
                    ciius_titulo: "Actividades de la Compañia (CIIUS)",
                    municipios: "Codificación Interna de Municipios",
                    ciiusPorMunicipio: "Tarifas de impuestos CIIUS por Municipio",
                    nit: "Nit",
                    razonSocial: "Razón Social",
                    departamento: "Departamento",
                    municipio: "Municipio",
                    codigo_interno: "Codigo Interno",
                    direccion: "Dirección",
                    loading: "Cargando...",
                    noData: "No hay información de la compañía",
                    noResults: "Seleccione una compañía y presione Consultar",
                    nuevoFormulario: "Agregar Compañía",
                    actualizaMunicipio: "Codificacion Interna de Municipios",
                    actualizaMunicipioCiiu: "Tarifas de Impuestos CIIUS por Municipios",
                    todasCompanias: "-- Seleccione una compañía --",
                    consultar: "Consultar",
                };
            }
            return {
                titulo1: "Industry and Commerce",
                empresa: "Company",
                ciius: "CIIUS",
                municipios: "Municipalities",
                ciiusPorMunicipio: "CIIUS by Municipality",
                nit: "Nit",
                razonSocial: "Business Name",
                departamento: "Department",
                municipio: "Municipality",
                direccion: "Address",
                loading: "Loading...",
                noData: "No company information available",
                noResults: "Select a company and press Consult",
                nuevoFormulario: "Add Company",
                todasCompanias: "-- Select a company --",
                consultar: "Consult",
            };
        },
        opcionesCompanias() {
            return (this.listaCompanias || []).map((c) => ({
                nit: c.nit,
                label: `${c.nit} - ${c.razon_social}`,
            }));
        },
        opcionesDepartamentos() {
            return (this.departamentos || []).map(d => ({
                value: d.divipol_depto,
                text: `${d.divipol_depto} - ${d.descripcion}`
            }));
        },
        opcionesMunicipiosForm() {
            if (!this.formCompania.divipol_depto) return [];
            return (this.municipios || [])
                .filter(m => m.divipol_depto == this.formCompania.divipol_depto)
                .map(m => ({
                    value: m.divipol_municipio,
                    text: `${m.divipol_municipio} - ${m.descripcion}`
                }));
        },
        opcionesCiius() {
            return (this.ciius || []).map(c => ({
                value: c.ciiu,
                text: `${c.ciiu} - ${c.descripcion}`
            }));
        },
        allFieldsCiius() {
            return [
                { key: 'ciiu', label: this.labels.ciius, sortable: false },
                { key: 'alterno', label: 'Código Alterno', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'descripcion', label: 'Descripción', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'principal_desc', label: 'Principal', sortable: false, tdClass: 'nowrap-cell' },
            ];
        },
        allFieldsMunicipios() {
            return [
                { key: 'codigo_municipio', label: 'Código Municipio', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'descripcion_municipio', label: this.labels.municipio, sortable: false, tdClass: 'nowrap-cell' },
                { key: 'municipio', label: this.labels.codigo_interno, sortable: false, tdClass: 'nowrap-cell' },
                { key: 'accionEdit', label: 'Editar', sortable: false, thStyle: 'width: 70px;', thClass: 'text-center' },
                { key: 'accionDelete', label: 'Eliminar', sortable: false, thStyle: 'width: 70px;', thClass: 'text-center' },
            ];
        },
        allFieldsMunicipiosCiius() {
            return [
                { key: 'codigo_municipio', label: 'Código Municipio', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'descripcion_municipio', label: this.labels.municipio, sortable: false, tdClass: 'nowrap-cell' },
                { key: 'ciiu', label: this.labels.ciius, sortable: false },
                { key: 'alterno', label: 'Alterno', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'porcentaje', label: 'Tarifa', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'valorxmillon', label: 'ValorxMillon', sortable: false, tdClass: 'nowrap-cell' },
                { key: 'accionEdit', label: 'Editar', sortable: false, thStyle: 'width: 70px;', thClass: 'text-center' },
                { key: 'accionDelete', label: 'Eliminar', sortable: false, thStyle: 'width: 70px;', thClass: 'text-center' },
            ];
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
                searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
                rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
                noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
                sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
                sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
                columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
                showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
                filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
                clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
            };
        },
    },
    methods: {
        guardarMunicipio() {
            this.infoItem.divipol_depto = this.formCompania.divipol_depto
            this.infoItem.divipol_municipio = this.formCompania.divipol_municipio
            const c_informacion = {
                id: this.infoItem.id,
                divipol_depto: this.infoItem.divipol_depto,
                divipol_municipio: this.infoItem.divipol_municipio,
            }
            Companias.actualiceMunicipios(c_informacion)
                .then(() => {
                    this.$toast.success("Codificacion Interna de Municipios actualizada correctamente")
                    this.consultar()
                })
            this.fglEditMunicipios = false
        },
        guardarMunicipioCiiu() {
            const c_informacion = {
                id: this.infoItem.id,
                porcentaje: this.infoItem.porcentaje,
                valorxmillon: this.infoItem.valorxmillon,
            }
            Companias.actualiceMunicipiosCiius(c_informacion)
                .then(() => {
                    this.$toast.success("Tarifas de Impuestos Ciius por Municipios actualizada correctamente")
                    this.consultar()
                })
            this.fglEditMunicipiosCiius = false
        },
        goBack() {
            this.$router.back();
        },
        abrirNuevoFormulario() {
            this.formCompania = {
                nit: '',
                razon_social: '',
                divipol_depto: null,
                divipol_municipio: null,
                direccion: '',
                actividades: [],
                autoretenedor: false
            };
            this.showNuevoFormulario = true;
        },
        cerrarModalCompania() {
            this.showNuevoFormulario = false;
            this.consultar();
        },
        guardarCompania() {
            console.log("Datos a guardar:", this.formCompania);
            this.$toast.success('Compañía guardada correctamente (simulado)');
            this.showNuevoFormulario = false;
            this.consultar();
        },
        itemCompania() {
            this.compania.compania_departamento = this.f_departamento(this.compania.divipol_depto);
            this.compania.compania_municipio = this.f_municipio(this.compania.divipol_depto, this.compania.divipol_municipio);
        },
        f_departamento(p_departamento) {
            const c_departamento = this.departamentos.find((r) => r.divipol_depto == p_departamento);
            return c_departamento ? c_departamento.descripcion : "Departamento " + p_departamento;
        },
        f_municipio(p_departamento, p_municipio) {
            const r_municipio = this.municipios.find(
                (r) => r.divipol_depto == p_departamento && r.divipol_municipio == p_municipio
            );
            return r_municipio ? r_municipio.descripcion : "Municipio " + p_departamento + " " + p_municipio;
        },
        consultar() {
            if (!this.nitSeleccionado) {
                this.$toast.warning("Por favor, seleccione una compañía.");
                return;
            }
            this.cargarDatosPorNit(this.nitSeleccionado);
        },
        async cargarDatosPorNit(nit) {
            this.isLoading = true;
            try {
                const [companiaRes, companiaMunicipiosRes, companiaCiiusRes, companiaMunicipiosCiiusRes] = await Promise.all([
                    Companias.leaCompania(nit),
                    Companias.leaCompaniaMunicipios(nit),
                    Companias.leaCompaniaCiius(nit),
                    Companias.leaCompaniaMunicipiosCiius(nit),
                ]);
                
                this.compania = companiaRes.data.compania[0] || {};
                this.companiaMunicipios = companiaMunicipiosRes.data.companiaMunicipio || [];
                this.companiaCiius = companiaCiiusRes.data.companiaCiius || [];
                this.companiaMunicipiosCiius = companiaMunicipiosCiiusRes.data.companiaMunicipiosCiius || [];
                
                this.itemCompania();
            } catch (e) {
                console.log("Error al consultar: " + e);
                this.$toast.error("Error al cargar los datos de la compañía");
            } finally {
                this.isLoading = false;
            }
        },
        editMunicipios(item) {
            this.infoItem = item
            this.fglEditMunicipios = true        
        },
        editMunicipiosCiius(item) {
            this.infoItem = item
            const idx = this.companiaCiius.findIndex((item) => item.alterno == this.infoItem.alterno)
            this.infoItem.descripcion = this.companiaCiius[idx].descripcion
            this.fglEditMunicipiosCiius = true
        },
        deleteFactura(item) {
            this.$toast.warning('Eliminar: No Implementada ' + JSON.stringify(item));
        },
    },
    async mounted() {
        this.isLoading = true;
        try {
            const [companiaRes, municipiosRes, departamentoRes, ciiusRes] = await Promise.all([
                Companias.leaCompania(), 
                Divipol.leaMunicipios(),
                Divipol.leaDepartamentos(),
                Ciius.leaCiius()
            ]);

            this.listaCompanias = companiaRes.data.compania || [];
            this.departamentos = departamentoRes.data.departamento || [];
            this.municipios = municipiosRes.data.municipio || [];
            this.ciius = ciiusRes.data.ciius || [];
            
        } catch (e) {
            console.log("Error cargando catálogos: " + e);
        } finally {
            this.isLoading = false;
        }
    },
};
</script>

<style src="../main.css"></style>

<style scoped>
/* ====== HEADER & FILTROS ====== */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 300px;
    max-width: 450px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

/* ====== TARJETA DE RESULTADOS ====== */
.resumen-card {
    background: #fff !important;
    border-radius: 30px !important;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12) !important;
    padding: 40px !important;
}

/* ====== BARRA DE ACCIONES DENTRO DE LA TARJETA ====== */
.resumen-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
}

.resumen-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
}

.table-toolbar-add-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #28a745 !important;
    color: white !important;
    border: 1px solid #28a745 !important;
}

.table-toolbar-add-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ====== SCROLL INTERNO ====== */
.bloques-scroll {
    max-height: 70vh;
    overflow-y: auto;
    padding-right: 8px;
}

.bloques-scroll::-webkit-scrollbar {
    width: 8px;
}
.bloques-scroll::-webkit-scrollbar-thumb {
    background: #c7d0d9;
    border-radius: 4px;
}
.bloques-scroll::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

/* ====== BLOQUES ====== */
.resumen-bloque {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
}

.resumen-bloque + .resumen-bloque {
    margin-top: 8px;
}

.bloque-titulo {
    background: #d9eaf3;
    padding: 8px 12px;
    border-radius: 4px;
    font-weight: 600;
    margin: 0 0 4px 0;
}

/* ====== EMPRESA (grid de datos) ====== */
.empresa-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px 24px;
    padding: 12px 4px 4px 4px;
}

.empresa-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.empresa-label {
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.empresa-value {
    font-size: 14px;
    color: #212529;
    word-break: break-word;
}

/* ====== NEUTRALIZAR EL "CONTORNO TARJETA" DE CorporateDataTable ====== */
.resumen-bloque ::v-deep .table-corporate-shell,
.resumen-bloque ::v-deep .table-corporate-body,
.resumen-bloque ::v-deep .tblEstandar,
.resumen-bloque ::v-deep .tblCorporate,
.resumen-bloque ::v-deep .b-table-sticky-header,
.resumen-bloque ::v-deep .table-responsive,
.resumen-bloque ::v-deep .card,
.resumen-bloque ::v-deep .admin-table-block,
.resumen-bloque ::v-deep .corporate-data-table {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
}

.resumen-bloque ::v-deep .table-corporate-shell,
.resumen-bloque ::v-deep .table-corporate-body,
.resumen-bloque ::v-deep .table-responsive,
.resumen-bloque ::v-deep .tblEstandar,
.resumen-bloque ::v-deep .tblCorporate {
    margin: 0 !important;
    padding: 0 !important;
}

.resumen-bloque ::v-deep table.table {
    margin-bottom: 0 !important;
}

.resumen-bloque ::v-deep .table-corporate-toolbar {
    display: none !important;
}

.resumen-bloque ::v-deep .table-corporate-body {
    min-height: 0 !important;
    height: auto !important;
}

.resumen-bloque ::v-deep .table-corporate-shell,
.resumen-bloque ::v-deep .table-corporate-body,
.resumen-bloque ::v-deep .table-responsive,
.resumen-bloque ::v-deep .b-table-sticky-header,
.resumen-bloque ::v-deep .tblEstandar,
.resumen-bloque ::v-deep .tblCorporate,
.resumen-bloque ::v-deep table {
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
}

.resumen-bloque ::v-deep tbody tr:hover,
.resumen-bloque ::v-deep tbody tr:hover > td,
.resumen-bloque ::v-deep tbody tr:hover > th,
.resumen-bloque ::v-deep tbody tr:hover > * {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
    color: inherit !important;
    --bs-table-accent-bg: transparent !important;
    --bs-table-hover-bg: transparent !important;
}

.resumen-bloque ::v-deep tbody tr {
    cursor: default !important;
}

/* ====== CELDAS ====== */
:deep(.nowrap-cell) {
    font-size: 13px !important;
    white-space: normal !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
}

/* ====== ESTILOS DE MODAL Y UTILIDADES ====== */
.uniform-modal-body { padding: 8px 4px 4px 4px; }
.uniform-form-row { margin-bottom: 12px; }
.fila-field { display: flex; flex-direction: column; }
.field-label { font-size: 13px; font-weight: 500; margin-bottom: 4px; display: block; }
.form-input { width: 100%; height: 38px; font-size: 14px; border-radius: 7px; }
.password-policy-box { background: white; border-radius: 8px; padding: 16px 20px; border-left: 4px solid #2e507a; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.password-policy-title { font-weight: 600; font-size: 15px; color: #2e507a; margin-bottom: 4px; }
.password-policy-subtitle { font-size: 13px; color: #6c757d; }
.uniform-actions-wrap { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; padding-top: 16px; border-top: 1px solid #e9ecef; flex-shrink: 0; }
.reset-btn-primary { background-color: #2e507a !important; border: 1px solid #2e507a !important; color: white !important; padding: 8px 24px; border-radius: 6px; font-weight: 500; transition: all 0.2s ease; }
.reset-btn-primary:hover:not(:disabled) { background-color: #1f3f62 !important; border-color: #1f3f62 !important; }
.reset-btn-primary:disabled { opacity: 0.65; cursor: not-allowed; }
.reset-btn-secondary { background-color: #f8f9fa !important; border: 1px solid #ced4da !important; color: #495057 !important; padding: 8px 24px; border-radius: 6px; font-weight: 500; transition: all 0.2s ease; }
.reset-btn-secondary:hover:not(:disabled) { background-color: #e9ecef !important; border-color: #adb5bd !important; color: #495057 !important; }
.reset-btn-secondary:focus, .reset-btn-secondary:active { box-shadow: none !important; outline: none !important; }
.reset-btn-secondary:disabled { opacity: 0.65; cursor: not-allowed; }
.reset-btn-danger { background-color: #cd2838 !important; border: 1px solid #cd2838 !important; color: white !important; border-radius: 6px; }
.reset-modal-header { background-color: #2e507a; color: white; padding: 16px 20px; border-radius: 8px 8px 0 0; }
.reset-modal-title { font-size: 18px; font-weight: 600; margin: 0; }
.reset-modal-body { padding: 24px 20px; background-color: #f8f9fa; overflow: hidden; }

/* Toggles personalizados */
.custom-toggle-wrapper { display: inline-flex; align-items: center; gap: 8px; flex-shrink: 0; }
.custom-toggle-wrapper input[type="checkbox"] { display: none; }
.custom-toggle-wrapper .toggle-label { display: flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; margin: 0; }
.custom-toggle-wrapper .toggle-slider { position: relative; display: inline-block; width: 36px; height: 20px; background-color: #ccc; border-radius: 10px; transition: background-color 0.3s ease; flex-shrink: 0; box-shadow: inset 0 1px 2px rgba(0,0,0,0.15); }
.custom-toggle-wrapper .toggle-slider::after { content: ''; position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; background-color: white; border-radius: 50%; transition: transform 0.3s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.25); }
.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider { background-color: #2e507a; }
.custom-toggle-wrapper input[type="checkbox"]:checked + .toggle-label .toggle-slider::after { transform: translateX(16px); }
.custom-toggle-wrapper .toggle-text { font-size: 14px; font-weight: 500; color: #495057; }
.custom-toggle-wrapper.custom-toggle-sm .toggle-slider { width: 34px; height: 20px; }
.custom-toggle-wrapper.custom-toggle-sm .toggle-slider::after { width: 16px; height: 16px; }
.custom-toggle-wrapper.custom-toggle-sm input[type="checkbox"]:checked + .toggle-label .toggle-slider::after { transform: translateX(14px); }
.custom-toggle-wrapper.custom-toggle-sm .toggle-text { font-size: 12px; min-width: 48px; }

/* ====== RESPONSIVE ====== */
@media (max-width: 992px) {
    .empresa-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    .param-title {
        font-size: 1.5rem !important;
    }
    .niif-header .filter-select {
        min-width: 200px;
    }
}

@media (max-width: 576px) {
    .empresa-grid {
        grid-template-columns: 1fr;
    }
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        justify-content: flex-start;
        gap: 6px;
    }
    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        flex: 1 1 auto;
    }
    .niif-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>